import t from 'tcomb-validation'

/**
 * Generic Types
 */

const NonEmptyString = t.refinement(t.String, v => {
  return !!v.length
}, 'NonEmptyString')

/**
 * Type Assertion utility
 */

function assert (value, Type, name = 'value') {
  const err = t.validate(value, Type).firstError()
  if (err) {
    const wrapperError = new TypeError(`${name} is not ${Type.displayName} type: ${err.message}`)
    throw Object.assign(wrapperError, {
      status: 422
    }, err, wrapperError)
  }
  return value
}

/**
 * Wrap assert in Promise interface for async functions.
 * i.e. return Promise rejection instead of throwing
 */

function assertThen (...args) {
  return Promise.resolve().then(() => assert(...args))
}

/**
 * Exports
 */

export {
  t,
  NonEmptyString,
  assert,
  assertThen
}

export default {
  t,
  NonEmptyString,
  assert,
  assertThen
}



// WEBPACK FOOTER //
// ../webmango-types/index.js